module.exports = __webpack_public_path__ + "static/media/p_31_0.23370713.png";